export default "__VITE_ASSET__DbqKJcXR__"